import React, { useState } from "react";

interface SelectProps {
    id?: string;
    description: string;
    className?: string;
    populate?: dataMenu[];
    populateJob?: JobType[]
    type: string;
    value?:number;
    valueSlot?: number;
    onChange: (value: any) => void;
}

export interface dataMenu {
    description: string
}

interface JobType {
    id: string
    groupName: string;
    jobClass: string;
    jobType: string;
    jobTypeDesc: string;
    jobFriendlyName: InputConfig;
}
interface InputConfig {
    id: string;
    value: string;
}
interface SlotType {
    id: string
    slotType: string;
    slotFriendlyName: InputConfig;
    jobTypes: JobType[];
}


const Select = (props: SelectProps) => {
    const { onChange, description, className, populate, type, populateJob,value,valueSlot, id } = props;
    
    const whichRender = (type: string) => {
        if (type === "slot") {
            return <select
                /* required */
                value={value} 
                className={className}
                name=""
                id={id}
                onChange={e => onChange(e.target.value)}
            >
                <option value="">{description}</option>
                {populate?.map((el, index) => (<option key={index} value={index}>{el}</option>))}
            </select>
        }else{
            return <select
                /* required */
                className={className}
                name=""
                id={id}
                onChange={e => onChange(e.target.value)}
                value={valueSlot} 
            >
                <option value="">{description}</option>
                {populateJob?.map((el, index) => (<option key={index} value={index}>{el.jobTypeDesc}</option>))}
            </select>
        }
    }
   return whichRender(type)
}

export default Select;